const modalContent = {
  padding: '16px 0',
  overflowY: 'hidden',
  '@media (max-height: 760px)': {
    maxHeight: 'calc(100vh - 100px)',
  },
} as const;

const modalScrollContainer = {
  padding: '0 20px',
  overflowY: 'auto',
  '@media (max-height: 760px)': {
    maxHeight: 'calc(100vh - 260px)',
  },
} as const;

const selectMenuPaper = {
  top: '30% !important',
  bottom: '12%',
  '@media (max-height: 1000px)': { top: '22% !important' },
  '@media (max-height: 760px)': { top: '90px !important' },
} as const;

export { modalContent, modalScrollContainer, selectMenuPaper };
